module.exports = __webpack_public_path__ + "img/canda.b2e49678.png";